import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { extractMetricIds } from '~/functions/metrics';
import { TypeAggregationGroup, TypeMetricAssignedTo, useAddMetricAggregationBatchMutation, useAddMetricAssignmentBatchMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'AggregationBatchDialog',
  props: {
    portfolioId: null,
    type: null,
    selectedMetrics: null
  },
  setup: function setup(__props) {
    var props = __props;

    // const comment = ref<null | string>(null)
    var assigneeIds = ref([]);
    var fundIds = ref([]);
    var _useAddMetricAggregat = useAddMetricAggregationBatchMutation(),
      addMetricAggregationBatch = _useAddMetricAggregat.mutate,
      addMetricAggregationLoading = _useAddMetricAggregat.loading;
    var _useAddMetricAssignme = useAddMetricAssignmentBatchMutation(),
      addMetricAssignmentBatch = _useAddMetricAssignme.mutate;
    var disableSubmit = computed(function () {
      if (addMetricAggregationLoading.value) {
        return true;
      } else if (props.type === 'edit') {
        if (!assigneeIds.value.length) {
          return true;
        }
        return true;
      }
      return false;
    });
    var form = ref({
      validate: function validate() {
        return false;
      }
    });
    var filterToFund = function filterToFund(m) {
      return !m.assignedTo || [TypeMetricAssignedTo.Fund, TypeMetricAssignedTo.FundCompany].includes(m.assignedTo);
    };
    var filterForVirtualAggregations = function filterForVirtualAggregations(m) {
      return !m.assignedTo || [TypeMetricAssignedTo.Company].includes(m.assignedTo);
    };
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _form$value;
        var _fundIds$value, portfolioMetricIds, fundMetricAggregationIds, fundMetricAssignmentIds, assignmentInputs, _iterator, _step, metricId, _iterator2, _step2, _metricId, _iterator3, _step3, fundId, aggregationInputs, _iterator4, _step4, _metricId2, _iterator5, _step5, _fundId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(form !== null && form !== void 0 && (_form$value = form.value) !== null && _form$value !== void 0 && _form$value.validate())) {
                _context.next = 15;
                break;
              }
              portfolioMetricIds = extractMetricIds(props.selectedMetrics.filter(function (m) {
                return m.assignedTo === TypeMetricAssignedTo.FundMgmt;
              }));
              fundMetricAggregationIds = [].concat(_toConsumableArray(extractMetricIds(props.selectedMetrics.filter(filterToFund).filter(function (m) {
                return m.isComputed;
              }))), _toConsumableArray(extractMetricIds(props.selectedMetrics.filter(filterForVirtualAggregations).filter(function (m) {
                return !m.isComputed;
              }))));
              fundMetricAssignmentIds = extractMetricIds(props.selectedMetrics.filter(filterToFund).filter(function (m) {
                return !m.isComputed;
              })); // Aggregate all assignment inputs
              assignmentInputs = [];
              if (portfolioMetricIds !== null && portfolioMetricIds !== void 0 && portfolioMetricIds.length) {
                _iterator = _createForOfIteratorHelper(portfolioMetricIds);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    metricId = _step.value;
                    assignmentInputs.push({
                      metricId: metricId
                      // assign to ourself, no assigneeId needed
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              if (fundMetricAssignmentIds !== null && fundMetricAssignmentIds !== void 0 && fundMetricAssignmentIds.length) {
                _iterator2 = _createForOfIteratorHelper(fundMetricAssignmentIds);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _metricId = _step2.value;
                    _iterator3 = _createForOfIteratorHelper(fundIds.value);
                    try {
                      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        fundId = _step3.value;
                        assignmentInputs.push({
                          metricId: _metricId,
                          fundId: fundId
                          // assign to ourself, no assigneeId needed
                        });
                      }
                    } catch (err) {
                      _iterator3.e(err);
                    } finally {
                      _iterator3.f();
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              if (!assignmentInputs.length) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return addMetricAssignmentBatch({
                inputs: assignmentInputs
              });
            case 10:
              // Aggregate all aggregation inputs
              aggregationInputs = [];
              if (fundMetricAggregationIds !== null && fundMetricAggregationIds !== void 0 && fundMetricAggregationIds.length && fundIds !== null && fundIds !== void 0 && (_fundIds$value = fundIds.value) !== null && _fundIds$value !== void 0 && _fundIds$value.length) {
                _iterator4 = _createForOfIteratorHelper(fundMetricAggregationIds);
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    _metricId2 = _step4.value;
                    _iterator5 = _createForOfIteratorHelper(fundIds.value || []);
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        _fundId = _step5.value;
                        aggregationInputs.push({
                          metricId: _metricId2,
                          groupType: TypeAggregationGroup.Fund,
                          groupId: _fundId
                        });
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
              if (!aggregationInputs.length) {
                _context.next = 15;
                break;
              }
              _context.next = 15;
              return addMetricAggregationBatch({
                inputs: aggregationInputs
              });
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      assigneeIds: assigneeIds,
      fundIds: fundIds,
      addMetricAggregationBatch: addMetricAggregationBatch,
      addMetricAggregationLoading: addMetricAggregationLoading,
      addMetricAssignmentBatch: addMetricAssignmentBatch,
      disableSubmit: disableSubmit,
      form: form,
      filterToFund: filterToFund,
      filterForVirtualAggregations: filterForVirtualAggregations,
      submit: submit,
      TypeMetricAssignedTo: TypeMetricAssignedTo
    };
  }
});